export default import.meta.ROLLDOWN_FILE_URL_npxL4eWXIJH5QABfLaSn4g